import CardTermsBlock from '../../components/CardTermsBlock';
import PageHeader from '../../components/PageHeader';

import './CardTermsConditions.scss';

const CardTermsConditions = () => {
	return (
		<div className='CardTermsConditions'>
			<PageHeader />
			<div className='CardTermsConditions__body'>
				<CardTermsBlock />
			</div>
		</div>
	);
};

export default CardTermsConditions;
